import * as React from 'react';

import { translate } from '~l10n/client';

import { ViewPricingTableEventAdapter } from '~analytics/adapters/ViewPricingTableEventAdapter';
import { Badge } from '~shared/components/Badge';
import { SmallButton } from '~shared/components/buttons';
import { useAccount } from '~teacher/hook/account';

interface PlansOrProProps {
  isVisible: boolean;
}
export function PlansOrGetProButton({ isVisible }: PlansOrProProps) {
  const accountQuery = useAccount({
    select: ({ isPro }) => ({
      hasPro: isPro,
    }),
  });

  if (!isVisible) return null;

  return (
    <div data-testid="view-plans-get-pro" className="hidden tb:block">
      {accountQuery.data ? (
        <GetProButton hasPro={accountQuery.data?.hasPro} />
      ) : (
        translate('Loading…')
      )}
    </div>
  );
}

function GetProButton({ hasPro }: { hasPro: boolean }) {
  if (hasPro === false) {
    return (
      <SmallButton
        appearance="error"
        onClick={() => {
          new ViewPricingTableEventAdapter({
            source: 'header',
          }).sendAnalytics();
          window.SOCRATIVE.teacherRouter.routeToPricing();
        }}
      >
        {translate('Get')}
        <Badge className="ml-1">Pro</Badge>
      </SmallButton>
    );
  }

  return null;
}
